import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../../../chunks/tslib.es6.js";
import e from "../../../core/Accessor.js";
import { property as s } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as t } from "../../../core/accessorSupport/decorators/subclass.js";
import r from "../../../popup/ExpressionInfo.js";
import i from "../../../popup/FieldInfo.js";
import { getFieldInfoLabel as p } from "../support/featureUtils.js";

var l = /*#__PURE__*/function (_e) {
  _inherits(l, _e);

  var _super = _createSuper(l);

  function l(o) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this, o), _this.attributes = null, _this.expressionInfos = null, _this.description = null, _this.fieldInfos = null, _this.title = null;
    return _this;
  }

  _createClass(l, [{
    key: "formattedFieldInfos",
    get: function get() {
      var o = this.expressionInfos,
          e = this.fieldInfos,
          s = [];
      return null == e || e.forEach(function (e) {
        if (!(!e.hasOwnProperty("visible") || e.visible)) return;
        var t = e.clone();
        t.label = p(t, o), s.push(t);
      }), s;
    }
  }]);

  return l;
}(e);

o([s()], l.prototype, "attributes", void 0), o([s({
  type: [r]
})], l.prototype, "expressionInfos", void 0), o([s()], l.prototype, "description", void 0), o([s({
  type: [i]
})], l.prototype, "fieldInfos", void 0), o([s({
  readOnly: !0
})], l.prototype, "formattedFieldInfos", null), o([s()], l.prototype, "title", void 0), l = o([t("esri.widgets.Feature.FeatureFields.FeatureFieldsViewModel")], l);
var n = l;
export { n as default };